import React from 'react';
import { Phone, PhoneOutgoing } from 'lucide-react';
import { formatTime } from './constants';
import { convertTimeToLocation } from '../../common/constant/constant';

const CallSuccessNotice = ({ msgContent }) => {
  function formatCallDuration(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  let result = '';
  if (hours > 0) result += `${hours}h `;
  if (minutes > 0 || hours > 0) result += `${minutes}m `;
  result += `${remainingSeconds}s`;

  return result.trim();
}

function formatDateWithOriginalTime(inputDateStr) {
  const date = new Date(inputDateStr);
  
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${month}/${day} at ${hours}:${minutes} ${ampm}`;
}
  return (
    <div>
    <div className="flex items-center space-x-2 text-[#1B2A3D] font-medium text-sm">
      <PhoneOutgoing className="w-4 h-4 text-green-500" />
      <span>Call completed successfully in {formatCallDuration(msgContent.Duration)}</span>
    </div>
    <div className="text-xs text-right text-[#667783] py-3 block">{formatTime(convertTimeToLocation(msgContent.CallDateTime))}</div> 
    </div>
  );
};

export default CallSuccessNotice;
